import { http } from './http';
import { ROUTES } from './config';
import type { ProductSummary, TopWishlistedProduct } from '../types/ecommerce';

/** ProductService's wishlist client. Entirely customer-authenticated except the admin
 * analytics endpoint — unlike productsApi/reviewsApi there's no anonymous surface here. */
export const wishlistApi = {
  /** Cheap product-id set for heart-icon state across listing pages. */
  ids(): Promise<string[]> {
    return http.get(`${ROUTES.wishlist}/ids`);
  },

  /** Full product cards, most-recently-added first — the wishlist page. */
  list(): Promise<ProductSummary[]> {
    return http.get(ROUTES.wishlist);
  },

  add(productId: string): Promise<void> {
    return http.post(`${ROUTES.wishlist}/${productId}`);
  },

  remove(productId: string): Promise<void> {
    return http.delete(`${ROUTES.wishlist}/${productId}`);
  },

  /** Manager+ only — admin dashboard "most wishlisted" widget. */
  topWishlisted(limit = 8): Promise<TopWishlistedProduct[]> {
    return http.get(`${ROUTES.wishlist}/analytics/top?limit=${limit}`);
  },
};
